import { PersonalAccessToken } from '../../oauth2/personal.access.token';
import { SocketRoomEvent } from '../tenant.notification.payload';
import { RoomKey } from '../socket.room.key';

export const PersonalTokenEventType = {
    Created: 'created',
    Revoked: 'revoked',
} as const;

export type PersonalTokenRoomMessage =
    | SocketRoomEvent<typeof PersonalTokenEventType.Created, PersonalAccessToken>
    | SocketRoomEvent<typeof PersonalTokenEventType.Revoked, { tokenId: string }>;

export const PersonalTokenSettingsRooms = {
    userPersonalTokens: (userId: string): RoomKey<PersonalTokenRoomMessage> => ({ key: `settings:tokens:user:${userId}` }),
};
